module.exports = __webpack_public_path__ + "img/menu4.64d2fcb9.png";